document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('brand-logos-data');
  var titleEl = document.querySelector('.product__title');
  if (!dataEl || !titleEl) return;

  var logos;
  try {
    logos = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var vendorEl = titleEl.previousElementSibling;
  while (vendorEl && !vendorEl.classList.contains('product__text')) {
    vendorEl = vendorEl.previousElementSibling;
  }
  if (!vendorEl) return;

  var vendorName = vendorEl.textContent.trim();
  var logoUrl = logos[vendorName];
  if (!logoUrl) return;

  var img = document.createElement('img');
  img.src = logoUrl;
  img.alt = vendorName;
  img.className = 'product__brand-logo';
  img.loading = 'lazy';
  vendorEl.replaceWith(img);
});
